import React, { FC } from 'react';
import constants from '../../../../../core/constants';
import Frame from '../../../../components/Frame';
import useProfile from '../../../../hooks/useProfile';
import { FixedWithContainer } from '../../../common/CardBoardStyled';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';
import ModuleContainer from '@/presentation/components/Container';

interface IProps {
  handlerBack: any;
  subsectionHeader: any;
}

const ProgressiveCertificationsView: FC<IProps> = ({
  handlerBack,
  subsectionHeader
}) => {
  const { academic, getValue } = useProfile();

  return (
    <ModuleContainer containerType="subsection">
      <FixedWithContainer>
        <SubsectionHeader
          title={subsectionHeader[3].title}
          onClick={handlerBack}
        />
        <Frame
          source={`${constants.PE_URL}${constants.PE_PATH_PROGRESSIVE_CERTIFICATIONS}`}
          title="Portal del Estudiante"
        >
          <input type="hidden" name="emplid" value={getValue('emplid')} />
          <input type="hidden" name="grado" value={academic.career} />
          <input
            type="hidden"
            name="codutpalu"
            value={getValue('studentCode')}
          />
        </Frame>
      </FixedWithContainer>
    </ModuleContainer>
  );
};

export default ProgressiveCertificationsView;
